import React, { useRef, useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { Collapse } from '@material-ui/core';

import { ProcessStatus, TaskStatus } from '~/components/Details/getStatus';
import useOnClickOutside from '~/pages/utils/useOnclickOutside';

import {
  Container,
  CollapseHeader,
  CollapseContent,
  Subtitle,
  SubtitleIcon,
  SubtitleSpan,
} from './styles';

export interface StatusSubtitleProps {
  statuses: Array<ProcessStatus | TaskStatus>;
  getStatus: (status?: string) => { image: string; name: string };
}

const StatusSubtitle: React.FC<StatusSubtitleProps> = ({
  statuses,
  getStatus,
}) => {
  const [isOpened, setOpen] = useState(false);

  const collapseRef = useRef(null);

  const toggleCollapse = () => {
    setOpen(!isOpened);
  };

  useOnClickOutside(collapseRef, () => setOpen(false));

  return (
    <Container ref={collapseRef}>
      <CollapseHeader onClick={toggleCollapse}>
        <SubtitleIcon>
          <SubtitleSpan>Legenda do status</SubtitleSpan>
          {isOpened ? (
            <MdKeyboardArrowDown size={24} />
          ) : (
            <MdKeyboardArrowUp size={24} />
          )}
        </SubtitleIcon>
      </CollapseHeader>
      <Collapse in={isOpened}>
        <CollapseContent>
          {statuses.map((status) => (
            <Subtitle>
              <img src={getStatus(status).image} alt={getStatus(status).name} />
              <p>{getStatus(status).name}</p>
            </Subtitle>
          ))}
        </CollapseContent>
      </Collapse>
    </Container>
  );
};

export default StatusSubtitle;
